import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";

interface QuickNavigationItem {
  label: string;
  route: string;
}

interface QuickNavigationProps {
  icon: React.ReactNode;
  title?: string;
  actions: QuickNavigationItem[];
  description?: string;
}

const QuickNavigation: React.FC<QuickNavigationProps> = ({
  icon,
  title,
  actions,
  description = "",
}) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: "#fff",
        textAlign: "center",
        maxWidth: 350,
        mx: "auto",
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ fontSize: 40, mb: 1.5, color: "hsl(19 101% 51% / 1)" }}>
          {icon}
        </Box>
        <Typography
          variant="subtitle1"
          fontWeight={700}
          color="hsl(19 101% 51% / 1)"
          sx={{ mb: 2 }}
        >
          {title}
        </Typography>

        {description && (
          <Typography variant="subtitle2" color="#000" sx={{ mb: 2 }}>
            {description}
          </Typography>
        )}

        <Stack spacing={1}>
          {actions.map((action: QuickNavigationItem) => (
            <Button
              key={action.label}
              variant="contained"
              fullWidth
              sx={{
                bgcolor: "hsl(19 101% 51% / 1)",
                color: "#fff",
                borderRadius: 1.5,
                fontWeight: 600,
                fontSize: 16,
                "&:hover": {
                  bgcolor: "hsl(19 101% 41% / 1)",
                },
              }}
              onClick={() => navigate(action.route)}
            >
              {action.label}
            </Button>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default QuickNavigation;
